module.exports = __webpack_public_path__ + "img/twitter.f60435e9.svg";